.root {
  display: flex;
  flex-direction: column;
  gap: var(--dixa-size-spacer-100);
  margin: var(--dixa-size-spacer-300);
}

.composer {
  display: flex;
  flex-direction: column;
  gap: var(--dixa-size-spacer-200);
  padding: var(--dixa-size-spacer-250) var(--dixa-size-spacer-300);
  background: var(--dixa-color-neutral-100);
  border: var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);
  border-radius: var(--dixa-size-border-radius-100);
  cursor: text;
  transition: border-color 0.15s ease-out;

  &:focus-within {
    border-color: var(--dixa-color-neutral-900);
  }

  &.error {
    border-color: var(--dixa-color-red-600);
  }
}

.input {
  display: block;
  width: 100%;
  min-height: calc(3 * var(--dixa-typography-line-height-200));
  max-height: calc(10 * var(--dixa-typography-line-height-200));
  padding: 0;
  overflow-y: auto;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  field-sizing: content;
  color: var(--dixa-typography-color-primary);
  font-family: var(--dixa-typography-family-default);
  font-weight: var(--dixa-typography-weight-normal);
  font-size: var(--dixa-typography-size-200);
  line-height: var(--dixa-typography-line-height-200);
  letter-spacing: var(--dixa-typography-letter-spacing-200);

  &::placeholder {
    color: var(--dixa-color-neutral-500);
    opacity: 1;
  }

  &:disabled {
    cursor: default;
  }
}

.composer .action {
  background-color: var(--dixa-color-neutral-200);
  color: var(--dixa-color-neutral-800);

  &:hover {
    background-color: var(--dixa-color-neutral-300);
  }

  &:disabled {
    background-color: transparent;
    color: var(--dixa-color-neutral-400);
    opacity: 1;
  }
}
